import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ContractOverviewModel, PaginationPage, PaginationResponse } from 'src/app/classes';
import { AbstractListWidgetInner, WidgetInnerView } from 'src/app/widget-inner';
import { FilterType, FilterTypeCriteria, FilterTypes } from '../../../edit/edit-userfilter/edit-userfilter.component';
import * as globals from 'src/app/globals';
import { showAnimation } from 'src/animations';
import { ContractService } from 'src/app/lib/contract/services/contract.service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';
import { Contract } from 'src/app/lib/contract/classes';
import { MatDialog } from '@angular/material/dialog';
import { CreateContractDialogComponent } from 'src/app/lib/contract/components/dialog/create-contract-dialog/create-contract-dialog.component';

@Component({
  selector: 'app-contract-widget-inner',
  templateUrl: './contract-widget-inner.component.html',
  styleUrls: ['./contract-widget-inner.component.css'],
  animations: [showAnimation]
})
export class ContractWidgetInnerComponent extends AbstractListWidgetInner<ContractOverviewModel> {

  currentFilterType: FilterType<number> = FilterTypes.find(x => x.value == "Contract");

  currentView;
  userFilterIdentifier: number;

  constructor(
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetProviderService: IWidgetProviderService,
    private _router: Router,
    private _contractService: ContractService,
    private _dialog: MatDialog
  ) {
    super();
    this.sortAttribute = "contractnumber";
    this.currentFilterType = FilterTypes.find(x => x.value == "Contract");
    this.setInitialDefaultView();

    this.stringSearchProvider = (...args) => this._contractService.searchContractsByString(...args);
    this.userFilterSearchProvider = (...args) => this._contractService.searchContractsByUserFilter(...args);
  }

  addContract() {
    this._dialog.open(CreateContractDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false
    });
  }

  editContract(contract: Contract) {
    this._router.navigate(["/contract-details", contract.contractid]);
  }

  ngOnInit(): void {
    this._widgetProviderService.setWidgetInnerViews([
      {
        name: () => of('Neuen Vetrag anlegen'),
        icon: () => of('add'),
        onClick: () => {
          this.addContract();
          return of(null);
        },
        color: () => of(globals.widgetAdderColor)
      } as WidgetInnerView
    ]);
  }

  setDefaultView(view) {

    this.currentView = view;
    if (view.title) this.viewTitle = view.title;
    if (view.sortAttribute) this.sortAttribute = view.sortAttribute;
    if (view.sortDsc) this.sortDsc = view.sortDsc;

    this.userFilterIdentifier = 0;

    this.updateContentProvider(this.page.asObservable().pipe(switchMap((page: PaginationPage) => {
      return view.provider(this._contractService, page) as Observable<PaginationResponse<ContractOverviewModel[]>>;
    })));
  }

  setInitialDefaultView() {
    this.setDefaultView(ContractWidgetDefaultViews[0]);
  }

  setFilter(criteria: FilterTypeCriteria<number>) {
    if (criteria.value == this.sortAttribute) this.sortDsc = !this.sortDsc;
    else {
      this.sortAttribute = criteria.value;
      this.sortDsc = false;
    }
    this.sortEntries();
  }

  sortEntries() {
    var d = 1;
    if (this.sortDsc) d = -1;
    this.entries.sort((a, b) => {
      if (a[this.sortAttribute] > b[this.sortAttribute]) return 1 * d;
      else if (a[this.sortAttribute] < b[this.sortAttribute]) return -1 * d;
      return 0;
    });
  }

  ContractWidgetDefaultViews = ContractWidgetDefaultViews;

}

export const ContractWidgetDefaultViews = [
  {
    title: "Zuletzt verwendet",
    icon: "history",
    provider: function (contractService: ContractService, page: PaginationPage): Observable<PaginationResponse<ContractOverviewModel[]>> {
      return contractService.getUserContractHistory(page);
    }
  }, {
    title: "Beobachtete Verträge",
    icon: "visibility",
    provider: function (contractService: ContractService, page: PaginationPage): Observable<PaginationResponse<ContractOverviewModel[]>> {
      return contractService.getUserContractFavourites(page);
    }
  }
];
